// Decodifica (SIN verificar firma: eso lo hace el backend en el start) el token `lt`
// del alta en 1 paso, solo para pintar los datos del lead. Cualquier defecto → null
// → se cae al formulario generico.
export function decodeLeadToken(lt) {
  try {
    const parts = String(lt || "").split(".");
    if (parts.length !== 3) return null;
    const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
    const p = JSON.parse(json);
    if (p.kind !== "lead_signup") return null;
    if (!p.exp || p.exp < Math.floor(Date.now() / 1000)) return null;
    if (!p.negocio || !p.telefono) return null;
    return { nombre: p.nombre || "", negocio: p.negocio, telefono: p.telefono, sector: p.sector || null };
  } catch {
    return null;
  }
}
